const { assert } = require('../common/assert');
const { PrismoidSeriesContainer } = require('./prismoid-series-container');
const { XYRectangle } = require('./shapes');

// a bin container defined by a series of level rectangles
class RectangularContainer extends PrismoidSeriesContainer {
  constructor(rectangles) {
    assert(rectangles.length > 0, 'At least one rectangle must be provided');
    assert(rectangles.every(rectangle => rectangle instanceof XYRectangle, 'All elements must be instances of XYRectangle'));
    super(rectangles);
  }

  shapeToSurfacePoints(rectangle) {
    return [
      { x: rectangle.x1, y: rectangle.y1, z: rectangle.z },
      { x: rectangle.x2, y: rectangle.y1, z: rectangle.z },
      { x: rectangle.x2, y: rectangle.y2, z: rectangle.z },
      { x: rectangle.x1, y: rectangle.y2, z: rectangle.z },
    ];
  }

  interpolateZAtPoint(r1, r2, x, y) {
    assert(r2.fullyContains(r1), 'r2 must fully contain r1');
    assert(!r1.containsPoint(x, y), 'r1 must not contain the point');
    assert(r2.containsPoint(x, y), 'r2 must contain the point');

    const scalingFactors = [];
    if (x < r1.x1) {
      scalingFactors.push((r1.x1 - x) / (r1.x1 - r2.x1));
    }
    if (x > r1.x2) {
      scalingFactors.push((x - r1.x2) / (r2.x2 - r1.x2));
    }
    if (y < r1.y1) {
      scalingFactors.push((r1.y1 - y) / (r1.y1 - r2.y1));
    }
    if (y > r1.y2) {
      scalingFactors.push((y - r1.y2) / (r2.y2 - r1.y2));
    }
    assert(scalingFactors.length > 0, 'Unexpectedly found no solution');
    const scalingFactor = Math.max(...scalingFactors);
    return r1.z + (r2.z - r1.z) * scalingFactor;
  }
}

exports.RectangularContainer = RectangularContainer;
